import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Page, Row, Column } from 'components/shared/Layout';

import PassengerForm from './PassengerForm';
import Minors from './Minors';
import { bookingShape, historyShape, userShape } from 'constants/propTypes';

const Passengers = ({
  booking,
  reference,
  canEditPassengers,
  history,
  isGroupBooking,
  minorsAmount,
  minorOutbound,
  minorInbound,
  numberOfPassengers,
  bookingStatus,
  bookingReference,
  user
}) => (
  <Page>
    <Row>
      <Column>
        <h2>
          <FormattedMessage id="pnrTabs.passengers.title" />
        </h2>
      </Column>
    </Row>
    {isGroupBooking ? (
      <Minors
        minorsAmount={minorsAmount}
        minorOutbound={minorOutbound}
        minorInbound={minorInbound}
        numberOfPassengers={numberOfPassengers}
        bookingStatus={bookingStatus}
        bookingReference={bookingReference}
      />
    ) : null}
    <PassengerForm booking={booking} history={history} reference={reference} isFormEditable={canEditPassengers} user={user} />
  </Page>
);

Passengers.propTypes = {
  booking: bookingShape,
  reference: PropTypes.string.isRequired,
  canEditPassengers: PropTypes.bool.isRequired,
  history: historyShape,
  isGroupBooking: PropTypes.bool,
  minorsAmount: PropTypes.string,
  minorOutbound: PropTypes.string,
  minorInbound: PropTypes.string,
  numberOfPassengers: PropTypes.number,
  bookingStatus: PropTypes.string,
  bookingReference: PropTypes.string,
  user: userShape
};

export default Passengers;
